import { socketUpdateProgressV2, socketUpdateView } from "@/socket";
import utils from "@/utils";

export const shouldUpdateProgress = async (dbname, id, totallength) => {
  const metadata = await utils.getmetadata(dbname, id);
  let seconds =
    Math.floor(totallength) * 60 + (totallength - Math.floor(totallength)) * 60;
  if (
    metadata.currsecs >=
    parseFloat(process.env.NEXT_PUBLIC_VIDEO_COMPLETION_CRITERIA) *
      Math.floor(seconds)
  ) {
    return metadata.currsecs;
  }
  return 0;
};

export const shouldLastPlayStatusChange = (isPresent, ply) => {
  if (isPresent.lastplaystatus === undefined) return 0;
  if (
    Math.floor(ply?.currentTime()) - isPresent.lastplaystatus > 5 ||
    Math.floor(ply?.currentTime()) - isPresent.lastplaystatus < -5
  )
    return Math.floor(ply?.currentTime());
  else return isPresent.lastplaystatus;
};

export const viewsCount = async ({
  meta,
  cid,
  vid,
  uid,
  socket,
  isviewsCount,
}) => {
  //views count
  if (!meta.views) {
    let willcount = await isviewsCount(
      `${cid}_${vid._id}`,
      vid?.duration,
      meta
    );
    if (willcount) {
      socketUpdateView(
        {
          vid: vid._id,
          uid: uid,
        },
        socket
      );
    }
  }
};

export const videoStart = ({
  ply,
  prevMeta,
  isStarted,
  timestamp,
  makeVideoStart,
}) => {
  if (!isStarted && ply) {
    if (timestamp) ply.currentTime(timestamp);
    else if (prevMeta) {
      const lastPlayStatus =
        prevMeta.lastplaystatus - 10 > 0
          ? prevMeta.lastplaystatus - 10
          : prevMeta.lastplaystatus;
      ply.currentTime(lastPlayStatus);
    } else {
      ply.currentTime(0);
    }
    let isTourOpen = utils.getFromLocalStorage("site-tour-status");
    if (isTourOpen?.videoTour !== "YES") makeVideoStart();
  }
};

export const videoProgress = async ({
  isEnrolled,
  meta,
  vid,
  socket,
  shouldUpdateProgress,
  fetchProgress,
  ...id
}) => {
  if (id.cid) {
    //This checks 1) user enrolled course or not => returns undefined if not.
    //2) User completed this video before or not => returns false if not, we matters this.
    const isVideoAlreadyCompleted =
      isEnrolled &&
      isEnrolled?.seenContents?.some((vd) => vd.entityId === vid?._id);
    if (isVideoAlreadyCompleted === false) {
      //If not then checks the progress of current playing video, if 5% then will add or not.
      const isVideoCompleted = await shouldUpdateProgress(
        `${id.cid}_${vid._id}`,
        vid?.duration,
        meta
      );
      //at the end of the video playStatus change twice, due to which it get called twice and store two object of same videoid
      if (isVideoCompleted) {
        socketUpdateProgressV2(
          {
            uid: id.uid,
            eid: vid?._id,
            cid: id.cid,
          },
          socket
        );
        fetchProgress();
      }
    }
  }
};
